import AepRecommendations from '@components/pages/account/aep/recommendations';

export default AepRecommendations;
